import { useMemo } from 'react'

import { useSchedulingEnabled } from '@user/store/scheduling'
import type {
  CardClosingRequirements,
  ENTITY_TYPES,
  IServiceDTO,
} from '@sales-center/common'
import { useAppSelector } from '@user/store/hooks'
import {
  selectEntityAppointmentsSearch,
  selectEntityAppointmentsSearchLoading,
} from '@user/store/scheduling/searchSlice'
import { filterByEntity } from '@sales-center/common'

type Props = {
  entityId: number
  servicesCount: number
  services: IServiceDTO[]
  entityType: ENTITY_TYPES
  schedulingVisible: boolean
  requirements: CardClosingRequirements
}

export function useData(props: Props) {
  const {
    entityId,
    entityType,
    requirements,
    servicesCount,
    schedulingVisible,
  } = props

  const { agreementsCount, paymentsCount } = requirements

  const paymentIsComplete = paymentsCount > 0
  const serviceIsComplete = servicesCount > 0
  const agreementIsComplete = agreementsCount > 0

  const allAppts = useAppSelector(selectEntityAppointmentsSearch)
  const appointmentsLoading = useAppSelector(
    selectEntityAppointmentsSearchLoading,
  )

  const appts = useMemo(
    () => filterByEntity(allAppts, entityId, entityType),
    [allAppts, entityId, entityType],
  )

  const totalAppointmentCount = appts.length

  const schedulingComplete = totalAppointmentCount > 0

  const schedulingEnabled = useSchedulingEnabled()

  const showScheduling = schedulingVisible && schedulingEnabled

  return {
    showScheduling,
    paymentIsComplete,
    serviceIsComplete,
    schedulingComplete,
    agreementIsComplete,
    appointmentsLoading,
    totalAppointmentCount,
  }
}
